import AndroidInstallLink from "./AndroidInstallLink";
import { LocaleLink as Link } from "../../i18n/LocaleLink";
import { useTranslation } from "react-i18next";
import BrassMonogram from "./BrassMonogram";

export default function PageFooter() {
  const { t } = useTranslation();

  return (
    <footer
      className="relative z-10 mt-12 py-10 px-6"
      style={{ borderTop: "1px solid rgba(200,164,100,0.15)" }}
    >
      <div className="max-w-[1280px] mx-auto">
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-8 mb-10">
          <div className="col-span-2 sm:col-span-1">
            <div className="flex items-center gap-3 mb-3">
              <BrassMonogram size={22} />
              <span className="wordmark font-display italic text-[16px] text-parchment-300">
                astrogenesis
              </span>
            </div>
            <p className="font-body text-sm text-parchment-500 leading-relaxed max-w-[220px]">
              {t("ui.web.footer.tagline")}
            </p>
            <div className="mt-4"><AndroidInstallLink placement="footer" /></div>
          </div>

          <div>
            <p className="font-caps text-micro tracking-[0.2em] uppercase text-brass-400 mb-3">
              {t("ui.web.footer.journey")}
            </p>
            <div className="flex flex-col gap-2">
              <Link to="/" className="nav-link text-micro">
                {t("ui.web.footer.today")}
              </Link>
              <Link to="/cast" className="nav-link text-micro">
                {t("ui.web.footer.watch_cast")}
              </Link>
              <Link to="/ask" className="nav-link text-micro">
                {t("ui.web.footer.ask")}
              </Link>
              <Link to="/listen" className="nav-link text-micro">
                {t("ui.web.footer.listen")}
              </Link>
              <Link to="/discover" className="nav-link text-micro">
                {t("ui.web.footer.discover")}
              </Link>
              <Link to="/plans" className="nav-link text-micro">
                {t("ui.web.footer.plans")}
              </Link>
            </div>
          </div>

          <div>
            <p className="font-caps text-micro tracking-[0.2em] uppercase text-brass-400 mb-3">
              {t("ui.web.footer.explore")}
            </p>
            <div className="flex flex-col gap-2">
              <Link to="/benchmark" className="nav-link text-micro">
                {t("ui.web.footer.why_trust")}
              </Link>
              <Link to="/library" className="nav-link text-micro">
                {t("ui.web.footer.library")}
              </Link>
              <Link to="/library/discoveries" className="nav-link text-micro">
                {t("ui.web.footer.discoveries")}
              </Link>
              <Link to="/rules" className="nav-link text-micro">
                {t("ui.web.footer.rules")}
              </Link>
              <Link to="/cases" className="nav-link text-micro">
                {t("ui.web.footer.famous_lives")}
              </Link>
              <Link to="/mundane" className="nav-link text-micro">
                {t("ui.web.footer.mundane")}
              </Link>
              <Link to="/how-it-works" className="nav-link text-micro">
                {t("ui.web.footer.how_it_works")}
              </Link>
              <Link to="/faq" className="nav-link text-micro">
                {t("ui.web.footer.faq")}
              </Link>
            </div>
          </div>

          <div>
            <p className="font-caps text-micro tracking-[0.2em] uppercase text-brass-400 mb-3">
              {t("ui.web.footer.legal")}
            </p>
            <div className="flex flex-col gap-2">
              <Link to="/privacy" className="nav-link text-micro">
                {t("ui.web.footer.privacy")}
              </Link>
              <Link to="/terms" className="nav-link text-micro">
                {t("ui.web.footer.terms")}
              </Link>
              <Link to="/contact" className="nav-link text-micro">
                {t("ui.web.footer.contact")}
              </Link>
            </div>
          </div>
        </div>

        <div
          className="flex flex-col sm:flex-row items-center justify-between gap-4 pt-6"
          style={{ borderTop: "1px solid rgba(200,164,100,0.1)" }}
        >
          <p className="font-mono text-micro text-parchment-400">
            {/* Privacy copy (Section 7). Birth data IS transmitted to the
                server for chart computation (the API is stateless and does
                not persist it). The earlier wording "Birth data never
                stored" was accurate for persistence but read as "never
                leaves the device." The canonical wording is "never kept server-side" so the real flow stays explicit. */}
            © {new Date().getFullYear()} AstroGenesis. {t("ui.web.footer.birth_data_privacy", { lng: "en" })}
          </p>
          <div className="flex items-center gap-4">
            <a
              href="https://twitter.com/astrogenesis"
              target="_blank"
              rel="noopener noreferrer"
              aria-label={t("ui.web.footer.twitter")}
              className="inline-flex min-w-11 min-h-11 items-center justify-center font-mono text-micro text-parchment-400 hover:text-parchment-300 transition-colors"
            >
              𝕏
            </a>
            <a
              href="https://instagram.com/astrogenesis"
              target="_blank"
              rel="noopener noreferrer"
              aria-label={t("ui.web.footer.instagram")}
              className="inline-flex min-w-11 min-h-11 items-center justify-center font-mono text-micro text-parchment-400 hover:text-parchment-300 transition-colors"
            >
              IG
            </a>
            <a
              href="mailto:hello@astrogenesis.net"
              aria-label={t("ui.web.footer.email")}
              className="inline-flex min-w-11 min-h-11 items-center justify-center font-mono text-micro text-parchment-400 hover:text-parchment-300 transition-colors"
            >
              @
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
